import api from './api';
import BaseFinancialService, { handleApiError } from './financialService';

class ReceitaService extends BaseFinancialService {
  constructor() {
    super('/financeiro/receitas');
  }

  // Métodos específicos de receitas
  
  async getStats(mes = null, ano = null) {
    try {
      const params = {};
      if (mes) params.mes = mes;
      if (ano) params.ano = ano;
      
      const response = await api.get(`${this.endpoint}/stats/geral`, { params });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar estatísticas de receitas');
    }
  }

  async getAlertasVencendo(dias = 7) {
    try {
      const response = await api.get(`${this.endpoint}/alertas/vencendo`, {
        params: { dias }
      });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar receitas vencendo');
    }
  }

  async getAtrasadas() {
    try {
      const response = await api.get(`${this.endpoint}/alertas/atrasadas`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar receitas atrasadas');
    }
  }

  async registrarPagamento(receitaId, pagamentoData) {
    try {
      const response = await api.post(`${this.endpoint}/${receitaId}/pagamento`, pagamentoData);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao registrar pagamento');
    }
  }

  async aplicarJuros(receitaId) {
    try {
      const response = await api.post(`${this.endpoint}/${receitaId}/aplicar-juros`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao aplicar juros');
    }
  }

  async gerarDeContrato(contratoId) {
    try {
      const response = await api.post(`${this.endpoint}/gerar-de-contrato/${contratoId}`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao gerar fatura do contrato');
    }
  }
}

export default new ReceitaService();
